// extracted by mini-css-extract-plugin
module.exports = {"mobile":"360","tablet":"768","desktop":"1280","shortcuts":"_2CeGr","shortcutLink":"_1URDb"};